"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _global = _interopRequireDefault(require("global"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var _utilities = require("../../helpers/utilities");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CardSlider = /*#__PURE__*/function (_Component) {
  function CardSlider() {
    var _this;
    (0, _classCallCheck2["default"])(this, CardSlider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CardSlider, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      sliderWrapperPosition: {},
      sliderPosition: {},
      helperWrapperScrollLeft: 0
    });
    (0, _defineProperty2["default"])(_this, "updateHelperWrapperScroll", function () {
      return _this.setState({
        helperWrapperScrollLeft: _this.helperWrapperRef && _this.helperWrapperRef.scrollLeft
      });
    });
    (0, _defineProperty2["default"])(_this, "handleHelperWrapperArrows", function () {
      var flip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      _this.helperWrapperRef.scrollBy({
        left: flip ? -400 : 400,
        top: 0,
        behavior: 'smooth'
      });
      _this.updateHelperWrapperScroll();
    });
    (0, _defineProperty2["default"])(_this, "updateWrapperPosition", function () {
      var sliderWrapperPosition = _this.state.sliderWrapperPosition;
      sliderWrapperPosition = _this.sliderRowWrapper && _this.sliderRowWrapper.getBoundingClientRect();
      _this.setState({
        sliderWrapperPosition: sliderWrapperPosition
      });
    });
    (0, _defineProperty2["default"])(_this, "updateSliderPosition", function () {
      var sliderPosition = _this.state.sliderPosition;
      var parentOffset = _this.props.parentOffset;
      var newSliderPosition = _this.sliderElement && _this.sliderElement.getBoundingClientRect();
      // parentOffset is used on NON_FULL_WIDTH type where we need to get distance from parent's edge where slider needs to strech
      sliderPosition = {
        left: parentOffset || newSliderPosition && newSliderPosition.left,
        width: parentOffset ? newSliderPosition && newSliderPosition.width + parentOffset * 2 : newSliderPosition && newSliderPosition.width
      };
      _this.setState({
        sliderPosition: sliderPosition
      });
    });
    (0, _defineProperty2["default"])(_this, "handleResize", function () {
      _this.updateWrapperPosition();
      _this.updateSliderPosition();
    });
    // this function takes care of scrollbars creating overflow on Windows
    (0, _defineProperty2["default"])(_this, "handleFullWidthSizing", function () {
      var scrollbarWidth = _global["default"].innerWidth - document.body.clientWidth;
      _this.helperWrapperRef.style.width = "calc(100vw - ".concat(scrollbarWidth, "px)");
    });
    return _this;
  }
  (0, _inherits2["default"])(CardSlider, _Component);
  return (0, _createClass2["default"])(CardSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.type !== _constants.CARD_SLIDER_TYPES.NON_FULL_WIDTH) this.handleFullWidthSizing();
      this.handleResize();
      _global["default"].addEventListener('resize', (0, _utilities.throttle)(this.handleResize, 1000));
      this.helperWrapperRef.addEventListener('scroll', function (e) {
        return _this2.updateHelperWrapperScroll(e);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        this.handleResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      _global["default"].removeEventListener('resize', (0, _utilities.throttle)(this.handleResize, 1000));
      this.helperWrapperRef.removeEventListener('scroll', function (e) {
        return _this3.updateHelperWrapperScroll(e);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state = this.state,
        sliderWrapperPosition = _this$state.sliderWrapperPosition,
        sliderPosition = _this$state.sliderPosition,
        helperWrapperScrollLeft = _this$state.helperWrapperScrollLeft;
      var _this$props = this.props,
        children = _this$props.children,
        type = _this$props.type,
        parentOffset = _this$props.parentOffset,
        hideControls = _this$props.hideControls,
        alignItems = _this$props.alignItems,
        cardSize = _this$props.cardSize,
        className = _this$props.className,
        snap = _this$props.snap,
        upperArrows = _this$props.upperArrows,
        upperArrowText = _this$props.upperArrowText,
        hideFade = _this$props.hideFade;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('d8-c-card-slider', type, cardSize, hideFade && 'hide-fade', className),
        ref: function ref(el) {
          return _this4.sliderElement = el;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "slider--row",
        style: {
          height: sliderWrapperPosition.height
        }
      }, !upperArrows && !hideControls && helperWrapperScrollLeft > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-slider-controls left",
        style: {
          left: "-".concat(parentOffset ? sliderPosition.left - parentOffset : sliderPosition.left, "px"),
          height: "".concat(sliderWrapperPosition.height, "px"),
          width: "".concat(sliderPosition.left, "px")
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "control--wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this4.handleHelperWrapperArrows(true);
        },
        buttonType: _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
        buttonSize: _constants.BUTTON_SIZES.MEDIUM,
        icon: "arrow-left"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(el) {
          return _this4.helperWrapperRef = el;
        },
        className: "helper__wrapper ".concat(snap && 'card--snap'),
        style: {
          margin: "0px -".concat(sliderPosition.left, "px"),
          width: parentOffset && sliderPosition.width
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(el) {
          return _this4.sliderRowWrapper = el;
        },
        className: "slider--row__wrapper ".concat(alignItems && 'items-center'),
        style: {
          paddingRight: "".concat(sliderPosition.left, "px"),
          paddingLeft: "".concat(sliderPosition.left, "px")
        }
      }, children)), !upperArrows && !hideControls && children.length > 3 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-slider-controls right",
        style: {
          right: "-".concat(parentOffset ? sliderPosition.left - parentOffset : sliderPosition.left, "px"),
          height: "".concat(sliderWrapperPosition.height, "px"),
          width: "".concat(sliderPosition.left, "px")
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "control--wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this4.handleHelperWrapperArrows();
        },
        icon: "arrow-right",
        buttonType: _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
        buttonSize: _constants.BUTTON_SIZES.MEDIUM
      }))), upperArrows && children.length > 3 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "upper-control--wrapper items-center"
      }, upperArrowText && /*#__PURE__*/_react["default"].createElement("p", {
        className: "d8-u-text-bold"
      }, upperArrowText), /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this4.handleHelperWrapperArrows(true);
        },
        buttonType: _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
        buttonSize: _constants.BUTTON_SIZES.MEDIUM,
        icon: "arrow-left"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this4.handleHelperWrapperArrows();
        },
        icon: "arrow-right",
        buttonType: _constants.BUTTON_TYPES.CIRCLE_ICON_GHOST,
        buttonSize: _constants.BUTTON_SIZES.MEDIUM
      })))));
    }
  }]);
}(_react.Component);
CardSlider.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  type: _propTypes["default"].string,
  parentOffset: _propTypes["default"].number,
  hideControls: _propTypes["default"].bool,
  upperArrows: _propTypes["default"].bool,
  upperArrowText: _propTypes["default"].string,
  alignItems: _propTypes["default"].bool,
  cardSize: _propTypes["default"].string,
  className: _propTypes["default"].string,
  snap: _propTypes["default"].bool,
  hideFade: _propTypes["default"].bool
};
var _default = exports["default"] = CardSlider;